import React from "react";

import { getCategories } from "lib/product";
import Catalog from "../../catalogue";
import EmptyCatalogMessage from "../../../../components/design-system/organisms/EmptyCatalogMessage";

export default function SubcategoryPage({ category1, category, categories, catalogName }) {
  if (!category) {
    return <EmptyCatalogMessage />;
  }
  return <Catalog category={category} category1={category1} categories={categories} catalogName={catalogName} />;
}

export async function getStaticProps(context) {
  const categories = await getCategories();
  const formattedCategories = categories.map((category) => ({
    ...category,
    ...{ subcategories1: null, subcategories2: null },
  }));
  const category = categories.find((cat) => cat.slug === context.params.category)?.name.toLowerCase();
  const matchSubcategory = context.params.category1.replace("_", " ").match(/^(.+?)(?:~([0-9]+))?$/);
  const category1 = matchSubcategory[1];
  const catalogName = process.env.ALGOLIA_CATALOG_NAME;

  // No product of this category is available on the shop
  // We redirect the client to the global catalog page
  if (!category) {
    return {
      redirect: {
        destination: `/reconditionne/catalogue`,
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      category1,
      category,
      categories: formattedCategories,
      catalogName: catalogName,
    },
    revalidate: 30,
  };
}

export async function getStaticPaths() {
  const paths = [];
  return {
    paths,
    fallback: true,
  };
}
